/**
 * 上图标、下标题的图片文案组件
 */
import "./index.less";

export interface ImageAndTextProps {
  localName?: string;
  remoteUrl?: string;
  wrapStyle?: object;
  textStyle?: object;
  // https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.23&manage_type=myprojects&projectId=3809704 - iconfont-name (Symbol模式)
  iconName?: string;
  text?: string;
}

const classPrefix = "iot-component-image-and-text";

const ImageAndText: React.FC<ImageAndTextProps> = (props: ImageAndTextProps) => {
  const {
    localName,
    remoteUrl,
    wrapStyle = {},
    textStyle = {},
    iconName,
    text,
  } = props;
  let imgSrc = "";
  if (localName) {
    imgSrc = require(`/public/images/${localName}`);
  }
  if (remoteUrl) {
    imgSrc = remoteUrl;
  }
  return (
    <div className={`${classPrefix}`} style={wrapStyle}>
      <div className={`${classPrefix}-media`}>
        {imgSrc && <img src={imgSrc} alt={text || "image"} />}
        {iconName && (
          <svg className="icon svg-icon" aria-hidden="true">
            <use xlinkHref={`#${iconName}`}></use>
          </svg>
        )}
      </div>
      {text && (
        <div className={`${classPrefix}-text`} style={textStyle}>
          {text}
        </div>
      )}
    </div>
  );
};

export default ImageAndText;
